/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

/**
 * Skeleton that mirrors the EmbedHeader layout:
 * [back link skeleton] --- [title skeleton] --- [empty right]
 * with the same padding/border as the real EmbedHeader.
 *
 * This component does not set its own aria attributes — the parent
 * skeleton (RequestTypesSkeleton, HubsSkeleton, etc.) is responsible
 * for aria-busy / aria-label on the outer container.
 */

const styles = cssMap({
	wrapper: {
		paddingInline: token('space.400'),
		paddingBlockStart: token('space.250'),
		paddingBlockEnd: token('space.200'),
		borderBlockEndWidth: token('border.width'),
		borderBlockEndStyle: 'solid',
		borderBlockEndColor: token('color.border'),
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		flexShrink: 0,
	},
	left: {
		flex: '1 1 0%',
		display: 'flex',
		justifyContent: 'flex-start',
		minWidth: '0px',
	},
	center: {
		flex: '0 0 auto',
	},
	right: {
		flex: '1 1 0%',
	},
});

export const EmbedHeaderSkeleton = (): JSX.Element => {
	return (
		<div css={styles.wrapper}>
			<header css={styles.header} aria-hidden="true">
				<div css={styles.left}>
					{/* Back link skeleton: arrow icon + label */}
					<Skeleton
						width={160}
						height={token('space.400')}
						borderRadius={token('radius.medium')}
						isShimmering
					/>
				</div>
				<div css={styles.center}>
					{/* Title skeleton */}
					<Skeleton
						width={120}
						height={token('space.300')}
						borderRadius={token('radius.xsmall')}
						isShimmering
					/>
				</div>
				<div css={styles.right} />
			</header>
		</div>
	);
};
